const baseDomain = process.env.REACT_APP_DOMAIN || 'api.stock.faise.vn';

const buildUrls = (domain: string) => ({
    socketDataURL: `wss://${domain}/socket/data`,
    socketOrderURL: `wss://${domain}/socket/order`,
    authenURL: `https://${domain}/api/auth`,
    stockURL: `https://${domain}/api/data`,
    tradeURL: `https://${domain}/api/order`,
    userURL: `https://${domain}/profile`,
});

export const appUrls = buildUrls(baseDomain);